// extracted by mini-css-extract-plugin
module.exports = {"promotion":"promotion-module--promotion--2YPxS","promotionSecondary":"promotion-module--promotion-secondary--14RKo"};